import React from "react";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import postImage from "../../../images/no-image.png";
import toast from "react-hot-toast";
import { HiUserGroup, HiUserAdd, HiChevronRight, HiUsers } from 'react-icons/hi';

const CardTile = ({ familiesData, user, addBuddyRequest, buddies }) => {
  const cardData = [];
  familiesData?.forEach((item) => {
    cardData.push({
      id: item._id,
      title: item.family_name,
      name: `${item.primary_member_id?.first_name} ${item.primary_member_id?.last_name}`,
      image: item.image,
      primary_member_id: item?.primary_member_id?._id,
    });
  });

  let navigate = useNavigate();

  const handleIconClick = (member, id) => {
    user?.buddies?.includes(member)
      ? navigate("/family/members", { state: id })
      : toast.error("Request as buddy to access this family");
  };

  const addBuddyfromList = (buddyId, userId) => {
    confirmAlert({
      title: "Add Buddy Request",
      message: "Are you sure you want to send a buddy request?",
      buttons: [
        {
          label: "Yes",
          onClick: () => addBuddyRequest(buddyId, userId),
          className: "bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors duration-200"
        },
        {
          label: "No",
          className: "bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 transition-colors duration-200"
        },
      ],
      overlayClassName: "bg-gray-900 bg-opacity-50"
    });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {cardData.map((fData, index) => (
        <div
          key={index}
          className="overflow-hidden bg-white rounded-xl shadow-sm transition-all duration-300 hover:shadow-md"
        >
          <div className="relative aspect-[4/3] w-full bg-gray-100">
            {fData?.image?.length ? (
              <img
                crossOrigin="anonymous"
                src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${fData.image}`}
                className="object-cover w-full h-full"
                alt={`${fData.title} family`}
              />
            ) : (
              <div className="flex justify-center items-center w-full h-full bg-gray-100">
                <HiUserGroup className="w-20 h-20 text-gray-300" />
              </div>
            )}
          </div>

          <div className="p-4">
            <div className="text-center">
              <h3 className="font-semibold text-gray-900">{fData?.title}</h3>
              <p className="mt-1 text-sm text-gray-500">({fData?.name})</p>
            </div>

            <div className="mt-4 space-y-3">
              <button
                onClick={() => handleIconClick(fData?.primary_member_id, fData.id)}
                className="flex justify-center items-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <HiUsers className="mr-2 w-5 h-5" />
                View Members
                <HiChevronRight className="ml-auto w-5 h-5" />
              </button>

              <button
                onClick={() => addBuddyfromList(user?._id, fData?.primary_member_id)}
                disabled={buddies.includes(fData?.primary_member_id)}
                className={`flex justify-center items-center w-full px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  buddies.includes(fData?.primary_member_id)
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-indigo-50 text-indigo-600 hover:bg-indigo-100"
                }`}
              >
                <HiUserAdd className="mr-2 w-5 h-5" />
                {buddies.includes(fData?.primary_member_id) ? "Already Buddies" : "Add Buddy Request"}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardTile;
